export default __webpack_public_path__ + "static/media/support-not.d087cd3a.svg";